var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"switch"},[_c('input',{attrs:{"disabled":_vm.value,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('change',$event.target.value)}}}),_c('span',{staticClass:"slider"})])}
var staticRenderFns = []

export { render, staticRenderFns }